import React from "react";
import { Landmark, Flame } from "lucide-react";

function Logo({ src, Icon, testid }) {
  return src ? (
    <img src={src} alt="logo" data-testid={testid}
      className="w-[0.66in] h-[0.66in] object-contain bg-white rounded-full p-[2px] border-2 border-gold-400 shrink-0" />
  ) : (
    <div className="w-[0.66in] h-[0.66in] rounded-full border-2 border-gold-400 flex items-center justify-center shrink-0">
      <Icon className="w-7 h-7 text-gold-300" />
    </div>
  );
}

// Printed-card header: temple logo (left), temple name / location / card title, second temple logo (right).
export default function TempleCardHeader({ temple, templeName, location, title }) {
  return (
    <div className="bg-maroon-800 text-white px-3 py-1.5 flex items-center gap-2 border-b-[3px] border-gold-400">
      <Logo src={temple?.logo} Icon={Landmark} testid="card-logo-left" />
      <div className="flex-1 min-w-0 text-center leading-tight">
        {temple?.name_telugu && <p className="font-telugu text-gold-300 text-[17px] leading-tight" data-testid="card-temple-telugu">{temple.name_telugu}</p>}
        <p className="font-heading font-bold text-[14px] leading-tight" data-testid="card-temple-name">{templeName || temple?.name || "Temple"}</p>
        {(location || temple?.location) && <p className="text-[8px] tracking-[0.25em] text-gold-300 uppercase">{location || temple?.location}</p>}
        <p className="inline-block mt-1 px-3 py-[1px] rounded-full bg-gold-400 text-maroon-900 font-heading font-bold text-[9px] tracking-[0.25em] uppercase">{title}</p>
      </div>
      <Logo src={temple?.logo_right} Icon={Flame} testid="card-logo-right" />
    </div>
  );
}

// QR in a framed box with its number and a caption, so it scans reliably and reads clearly on paper.
export function CardQr({ src, code, testid }) {
  if (!src) return null;
  return (
    <div className="flex flex-col items-center">
      <div className="bg-white p-[3px] border-2 border-maroon-800 rounded-md">
        <img src={src} alt="QR code" className="w-[1.1in] h-[1.1in] block" style={{ imageRendering: "pixelated" }} data-testid={testid} />
      </div>
      {code && <p className="font-mono font-bold text-[8px] text-maroon-900 mt-0.5">{code}</p>}
      <p className="text-[6.5px] tracking-[0.2em] uppercase text-gold-700 font-bold">Scan to verify</p>
    </div>
  );
}
